import { render, staticRenderFns } from "./delete-bucket.html?vue&type=template&id=5ea5cc33&scoped=true&"
import script from "./delete-bucket.js?vue&type=script&lang=js&"
export * from "./delete-bucket.js?vue&type=script&lang=js&"
import style0 from "./delete-bucket.scss?vue&type=style&index=0&id=5ea5cc33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea5cc33",
  null
  
)

export default component.exports